/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SigningDropdownOptionViewModel
 */
export interface SigningDropdownOptionViewModel {
    /**
     * 
     * @type {string}
     * @memberof SigningDropdownOptionViewModel
     */
    optionValue: string;
    /**
     * 
     * @type {string}
     * @memberof SigningDropdownOptionViewModel
     */
    optionDescription: string;
}

/**
 * Check if a given object implements the SigningDropdownOptionViewModel interface.
 */
export function instanceOfSigningDropdownOptionViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "optionValue" in value;
    isInstance = isInstance && "optionDescription" in value;

    return isInstance;
}

export function SigningDropdownOptionViewModelFromJSON(json: any): SigningDropdownOptionViewModel {
    return SigningDropdownOptionViewModelFromJSONTyped(json, false);
}

export function SigningDropdownOptionViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): SigningDropdownOptionViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'optionValue': json['OptionValue'],
        'optionDescription': json['OptionDescription'],
    };
}

export function SigningDropdownOptionViewModelToJSON(value?: SigningDropdownOptionViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'OptionValue': value.optionValue,
        'OptionDescription': value.optionDescription,
    };
}

